import { ProposalState } from "..";

function AddPendingMaterialReducer(state: ProposalState) {
  state.pendingMaterials.push({
    commercialConditions: {
      packagedProductId: undefined,
      packagedProductUnitNb: "",
      category: undefined,
    },
  });
}

export default AddPendingMaterialReducer;
